import { generateActions } from "../generateActions";
import { eLopActionsObj } from "../../action-types/category/ILopActions";

export const lopActions = {
  ...generateActions(eLopActionsObj, "LOP"),
}